export const STRINGS = {
  loadingText: "Loading some spookiness...",
};
